import { CircularCheckbox } from 'components/CircularCheckbox'
import React from 'react'

export const VideoRatioType = () => {
  return (
    <div className="flex flex-col gap-[16px]">
      <div className="flex flex-col w-[343px] md:w-full ml-4 md:ml-0">
        <div className="mb-4">
          <label className="md:ml-0 font-bold text-[#2E343D] text-[24px] ">
            영상 비율 선택
          </label>
        </div>
        <div className="grid md:grid-cols-2 grid-cols-1 md:gap-0 gap-2">
          {[
            { name: '9:16 세로 ', value: true, type: '1' },
            { name: '16:9 가로 (준비중)', value: false, type: '2' },
          ]?.map((el, index) => {
            return (
              <>
                <div className="flex items-center " key={index}>
                  <CircularCheckbox
                    onChange={() => {}}
                    id={index}
                    disabled={!el.value}
                    label={el.name}
                    checked={el.value}
                  />
                  {el.type === '1' ? (
                    <>
                      <span className="w-[18px] h-[32px] border-[1px] border-[#B6BBC6] rounded-[2px] ml-2"></span>
                    </>
                  ) : (
                    <>
                      {' '}
                      <span className="h-[18px] w-[32px] border-[1px] border-[#B6BBC6] rounded-[2px] ml-2"></span>
                    </>
                  )}
                </div>
              </>
            )
          })}
        </div>
      </div>
    </div>
  )
}
